














import Vue from 'vue';
import { version } from '@/../package.json';

export default Vue.extend({
  computed: {
    year() {
      return new Date().getFullYear();
    },

    version() {
      return version || 0;
    },
  },
});
